import { useSearchPageData } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/__internal__/useSearchPageData";
export var useSearchPageQuery = function() {
    var _useSearchPageData = useSearchPageData(), productsData = _useSearchPageData.data, isFetching = _useSearchPageData.isFetching, isError = _useSearchPageData.isError, error = _useSearchPageData.error, dataUpdatedAt = _useSearchPageData.dataUpdatedAt;
    return {
        data: productsData === null || productsData === void 0 ? void 0 : productsData.response,
        isFetching: isFetching,
        isError: isError,
        error: error,
        dataUpdatedAt: dataUpdatedAt
    };
};
